import { Role } from '@/model/role';
import type { RouteRecordRaw } from 'vue-router';

const calendarLoading = () => import('@/components/calendar/Calendar.vue');

const Calendar = async () => await calendarLoading();

const calendarRoutes: RouteRecordRaw[] = [
  {
    path: '/agenda',
    name: 'Calendar',
    component: Calendar,
    meta: {
      role: Role.STAFF,
      title: 'Agenda',
    },
  },
];

export default calendarRoutes;
